import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var MusicNotesIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("g", {
                            clipPath: "url(#music-notes__a)",
                            children: _jsx("path", {
                                d: "M23.155 1.776c-.12-.25-.3-.46-.52-.64-.22-.17-.47-.28-.74-.33-.27-.05-.55-.04-.82.03l-12.73 3.54c-.38.1-.72.33-.95.64-.24.31-.37.7-.37 1.09v9.37c-.65-.4-1.4-.63-2.19-.63-1.12 0-2.17.44-2.96 1.23a4.16 4.16 0 00-1.23 2.96c0 1.12.44 2.17 1.23 2.96a4.16 4.16 0 002.96 1.23c1.12 0 2.17-.44 2.96-1.23s1.22-1.84 1.22-2.95v-8l12.33-3.42v3.89c-.19-.11-.38-.23-.58-.31-1.54-.64-3.38-.27-4.56.91a4.16 4.16 0 00-1.23 2.96c0 1.12.43 2.17 1.23 2.96a4.192 4.192 0 005.92-.01 4.192 4.192 0 001.23-2.96v-12.5c0-.28-.07-.55-.19-.79h-.01zm-16.78 18.8c-.81.81-2.28.81-3.09 0a2.172 2.172 0 010-3.08c.41-.41.97-.64 1.54-.64a2.19 2.19 0 012.18 2.18c0 .58-.23 1.13-.64 1.54h.01zm2.64-11.62v-2.7l12.33-3.42v2.69l-12.33 3.42v.01zm12.16 6.93c-.11.27-.27.5-.47.71-.2.2-.44.36-.71.47-.8.33-1.76.14-2.38-.47-.41-.41-.64-.96-.64-1.55 0-.59.23-1.13.64-1.54.41-.41.96-.64 1.54-.64.29 0 .57.06.83.17a2.147 2.147 0 011.18 1.18c.11.27.17.55.17.84 0 .29-.06.57-.17.84l.01-.01z"
                            })
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "music-notes__a",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
MusicNotesIcon.isCarinaIcon = true;
export default MusicNotesIcon;
